import { ParticipantView } from './ParticipantView';
import { DateTime } from 'luxon';

export interface GroupView {
  pledge: number | undefined;
  participants: ParticipantView[];
  cohortUserId: number;
  id: number;
  name: string;
  shortDescription: string;
  userCount: number;
  startDate: DateTime | string;
  groupLogo: string;
  pledgeReceived: boolean;
  channel: string;
  inPersonCelebration: boolean;
  currentWeekNumberIndexZero: number;
  finalized: boolean;
}

const empty: GroupView = {
  pledge: undefined,
  participants: [] as ParticipantView[],
  cohortUserId: 0,
  id: 0,
  name: '',
  shortDescription: '',
  userCount: 12,
  startDate: DateTime.now().plus({ month: 1 }),
  groupLogo: '',
  pledgeReceived: false,
  channel: '',
  inPersonCelebration: false,
  currentWeekNumberIndexZero: 0,
  finalized: false,
};

const defaultExport = { Empty: empty };
export default defaultExport;
